module.exports = __webpack_public_path__ + "static/media/4.767f0bbb.jpg";